type BaseAccountCardProps = {
  children: React.ReactNode;
  className?: string;
};

const BaseAccountCard = ({ children, className }: BaseAccountCardProps) => {
  return (
    <div
      className={`h-full bg-white p-8 shadow-lg sm:w-[440px] sm:rounded-2xl ${className} grow sm:grow-0`}
    >
      {children}
    </div>
  );
};

export default BaseAccountCard;
